export const movementEffect = (container, element) => {
  let constrainy = 24000;
  let constrainx = 14000;
  let mouseOverContainer = document.getElementById(container);
  let ex1Layer = document.getElementById(element);
  function transforms(x, y, el) {
    let box = el.getBoundingClientRect();
    let calcX = -(y - box.y - box.height / 2) / constrainx;
    let calcY = (x - box.x - box.width / 2) / constrainy;

    return (
      "perspective(100px) " +
      "   rotateX(" +
      calcX +
      "deg) " +
      "   rotateY(" +
      calcY +
      "deg) "
    );
  }

  function transformElement(el, xyEl) {
    el.style.transform = transforms.apply(null, xyEl);
  }

  mouseOverContainer.onmousemove = function (e) {
    let xy = [e.clientX, e.clientY];
    let position = xy.concat([ex1Layer]);

    window.requestAnimationFrame(function () {
      transformElement(ex1Layer, position);
    });
  };
};
